"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUserInfo = buildUserInfo;
exports.connectAuAnalyticsToHistory = connectAuAnalyticsToHistory;
exports.default = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _reactGa = _interopRequireDefault(require("react-ga4"));
var _DataDogRUM = _interopRequireDefault(require("./DataDogRUM"));
var _HubSpot = _interopRequireDefault(require("./HubSpot"));
let ga = false;
let dd = false;
let hs = false;
const AuAnalytics = {
  initialize(options) {
    if (options.ga) {
      _reactGa.default.initialize(options.ga.trackingId, options.ga.options);
      ga = true;
    }
    if (options.dd) {
      _DataDogRUM.default.initialize(options.dd.config, options.dd.userInfo);
      dd = true;
    }
    if (options.hs) {
      _HubSpot.default.initialize(options.hs.config, options.hs.userInfo);
      hs = true;
    }
  },
  trackPage(page, title) {
    ga && _reactGa.default.send({
      hitType: 'pageview',
      page,
      title
    });
    hs && _HubSpot.default.pageview(page);
  },
  trackEvent(event, params) {
    ga && _reactGa.default.event(event, params);
    hs && _HubSpot.default.event(event);
  },
  trackException(description, fatal = false) {
    ga && _reactGa.default.event('exception', {
      description,
      fatal
    });
  },
  formatTrackingText(txt) {
    // Capitalize text
    // Make sure we have a string to modify, seems to occasionally get an unexpected value (still tracking this down)
    return txt && typeof txt === 'string' ? `${txt.charAt(0).toUpperCase()}${(0, _slice.default)(txt).call(txt, 1)}` : '';
  }
};
let previousPath;
function connectAuAnalyticsToHistory(history) {
  history.listen(loc => {
    const currentPath = loc.pathname + loc.hash + loc.search;
    if (previousPath === currentPath) {
      return;
    }
    AuAnalytics.trackPage(currentPath);
    previousPath = currentPath;
  });
  return history;
}
function buildUserInfo(authClient) {
  // fields that should always be present
  //  https://autonomic-ai.atlassian.net/wiki/spaces/DA/pages/1099890871/JWTs
  const userInfo = {
    userId: authClient.userName,
    name: authClient.name,
    accountId: authClient.accountId
  };

  // fields that might be present
  //  https://www.pivotaltracker.com/n/projects/2354758/stories/173282418
  if (authClient.email) {
    userInfo.email = authClient.email;
  }
  if (authClient.givenName) {
    userInfo.firstname = authClient.givenName;
  }
  if (authClient.familyName) {
    userInfo.lastname = authClient.familyName;
  }
  return userInfo;
}
var _default = AuAnalytics;
exports.default = _default;